import React, { useMemo } from 'react';
import styled from 'styled-components';

import GaugeChart from 'react-gauge-chart';

import { Text } from 'components/Text';
import { progressColors } from '../constants';


const ProcessSpeedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PROCESS_SPEED_NR_LEVELS = 3;

export const round = (num, precision = 0) => {
  return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
};

const ProcessSpeed = ({ label, speedLevel, speedColor, style = {} }) => {
  const colors = useMemo(() => {
    const colors = new Array(PROCESS_SPEED_NR_LEVELS).fill('#45494D');
    if (speedLevel > 0) {
      colors[speedLevel - 1] = progressColors[speedColor];
    }
    return colors;
  }, [speedLevel, speedColor]);

  const percent = useMemo(() => {
    if (speedLevel === 0) return 0;
    const progressPerLevel = 1 / PROCESS_SPEED_NR_LEVELS;
    return round((speedLevel - 1) * progressPerLevel + progressPerLevel / 2, 2);
  }, [speedLevel]);

  return (
    <ProcessSpeedWrapper style={style}>
      <GaugeChart
        id="processSpeed"
        hideText={true}
        nrOfLevels={PROCESS_SPEED_NR_LEVELS}
        colors={colors}
        percent={percent}
        arcPadding={0.04}
        arcWidth={0.35}
        cornerRadius={0}
        needleColor="#FFFFFF"
        needleBaseColor="#FFFFFF"
        animate={false}
        // marginInPercent={0.075}
        marginInPercent={0}
        style={{
          width: '90%'
        }}
      />
      <Text
        style={{
          color: '#FFFFFF',
          fontWeight: 700,
          fontSize: '2vw',
          marginTop: '2.5vh',
          lineHeight: 1.1,
        }}
      >
        {label}
      </Text>
    </ProcessSpeedWrapper>
  );
};

export default ProcessSpeed;
